// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2C2.9 2 2 2.9 2 4',
  'M12 2C12.83 2 13.54 2.5 13.84 3.22',
  'M2 12C2 12.83 2.5 13.54 3.22 13.84',
  'M6.4 2H9.4M2 6.4V9.4M5.35 14H7M14 5.35V7',
  'M8.2 8.51C8.07 8.17 8.17 8.07 8.51 8.2L13.99 10.3C14.33 10.43 14.33 10.56 13.98 10.67L11.97 11.34C11.66 11.45 11.45 11.66 11.34 11.97L10.67 13.98C10.56 14.33 10.43 14.33 10.3 13.99Z',
];
